import SourceDepthBadge from './SourceDepthBadge'
import type { SourceDepthLevel, SourceDepthSummary } from '../api/apiClient'

const LEVELS: Array<{ level: SourceDepthLevel; label: string; description: string }> = [
  {
    level: 'foundation',
    label: 'Foundation',
    description: 'Built from the site profile and persona setup.',
  },
  {
    level: 'referenced',
    label: 'Referenced',
    description: 'Includes additional supporting source material.',
  },
  {
    level: 'developed',
    label: 'Developed',
    description: 'Includes multiple supporting sources or source types.',
  },
  {
    level: 'deep_archive',
    label: 'Deep Archive',
    description: 'Broad source set with stronger provenance and retrieval depth.',
  },
]

const makeDepth = (level: SourceDepthLevel, label: string): SourceDepthSummary => ({
  level,
  label,
  context_count: level === 'foundation' ? 0 : 1,
  source_count: level === 'foundation' ? 0 : 1,
  source_types: [],
  corpus_lanes: [],
})

const SourceDepthExplainer = () => (
  <aside className="source-depth-explainer" aria-label="Source depth explained">
    <div className="source-depth-explainer-intro">
      <p className="eyebrow">Source coverage</p>
      <h2>How prepared is each figure?</h2>
      <p>
        This is not a truth score; it shows how much supporting material has been prepared for this figure.
      </p>
    </div>
    <ul className="source-depth-explainer-list">
      {LEVELS.map((item) => (
        <li key={item.level}>
          <SourceDepthBadge depth={makeDepth(item.level, item.label)} variant="compact" />
          <span>{item.description}</span>
        </li>
      ))}
    </ul>
  </aside>
)

export default SourceDepthExplainer
